import React from "react";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import benefitsStyle from "assets/jss/material-kit-pro-react/Pages/landingPageSections/benefitsStyle.js";

const useStyles = makeStyles(benefitsStyle);

export default function SectionBenefits() {
  const classes = useStyles();

  const benefits = [
    {
      icon: <MonetizationOnIcon className={classes.icon} />,
      titleId: "land.benefits.card1_title",
      titleDefault: "Redução de Custos",
      descId: "land.benefits.card1_description",
      descDefault:
        "Substitua a inspeção manual por IA e reduza drasticamente os custos operacionais de controle de qualidade.",
    },
    {
      icon: <CheckCircleIcon className={classes.icon} />,
      titleId: "land.benefits.card2_title",
      titleDefault: "Zero Defeitos Escapados",
      descId: "land.benefits.card2_description",
      descDefault:
        "Detecte defeitos em tempo real com precisão superior à inspeção humana, antes que cheguem ao cliente.",
    },
    {
      icon: <DeleteSweepIcon className={classes.icon} />,
      titleId: "land.benefits.card3_title",
      titleDefault: "Menos Sucata",
      descId: "land.benefits.card3_description",
      descDefault:
        "Identifique falhas na origem do processo produtivo e reduza significativamente as perdas de material.",
    },
    {
      icon: <TrendingUpIcon className={classes.icon} />,
      titleId: "land.benefits.card4_title",
      titleDefault: "Mais Produtividade",
      descId: "land.benefits.card4_description",
      descDefault:
        "Inspecione mais peças por hora sem ampliar o quadro de pessoal, com maior consistência e repetibilidade.",
    },
  ];

  return (
    <div className={classes.section}>
      <div className={classes.sectionInner}>
        <h2
          className={classes.sectionTitle}
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
        >
          <FormattedMessage
            id="land.benefits.title"
            defaultMessage="Resultados Reais para a Indústria"
          />
        </h2>
        <p
          className={classes.sectionSubtitle}
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
        >
          <FormattedMessage
            id="land.benefits.subtitle"
            defaultMessage="A inspeção de qualidade automatizada com IA transforma os indicadores da sua linha de produção"
          />
        </p>
        <div className={classes.grid}>
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={classes.card}
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay={String(index * 80)}
            >
              <div className={classes.iconWrapper}>{benefit.icon}</div>
              <h3 className={classes.cardTitle}>
                <FormattedMessage
                  id={benefit.titleId}
                  defaultMessage={benefit.titleDefault}
                />
              </h3>
              <p className={classes.cardDescription}>
                <FormattedMessage
                  id={benefit.descId}
                  defaultMessage={benefit.descDefault}
                />
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
